import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import {listParameters, listInterfaces, getParameter} from '../utils/utilsInterface'

class SelectParameter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectInterface: false,
            label: "Parameter",
            idSelected: "",
            idInterface: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectInterface = getParam('selectInterface',this.props);
        StateChange.idInterface = getParam('idInterface', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectInterface){
            this.loadInterfaces();
        }

        if (StateChange.idInterface){
            this.loadParameters(StateChange.idInterface);
        }

        if (StateChange.idSelected){
            this.loadSelectedParameter(StateChange.idSelected);
        }

        this.setState(StateChange);


    }



    loadSelectedParameter(idParameter){

        if (!idParameter){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Parameter) => {
            const StateChange = {
                SelectedParameter: Parameter,
                renderState: "loaded"
            };
            
            if (Parameter.Interface){
                StateChange.idInterface = Parameter.Interface._id;
                this.loadParameters(StateChange.idInterface);
            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load parameter"
            });
        };

        getParameter(this.dsd, idParameter, onLoad, onFail);
        
    };



    loadParameters(idInterface){

        this.setState({renderState: "loading"});

        const onLoad = (Parameters) => {
            this.setState({
                Parameters: Parameters,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load parameters"
            });
        };

        listParameters(this.dsd, {idInterface: idInterface}, onLoad, onError);

    };


    loadInterfaces(){

        this.setState({renderState: "loading"});

        const onLoad = (Interfaces) => {
            this.setState({
                Interfaces: Interfaces,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load interfaces"
            });
        };

        listInterfaces(this.dsd, {}, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idInterface":
                this.setState({"idInterface":FormFieldValue});
                if (FormFieldValue){
                    this.loadParameters(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectInterface && this.state.Interfaces &&
                            <PD.Select label='Select a Logical Model' name='idInterface' onChange={this.handleChange} value={this.state.idInterface}>
                                {
                                    this.state.Interfaces.map(
                                        (Interface, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Interface._id}>{Interface.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Parameters &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Parameters.map(
                                        (Parameter, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Parameter._id}>{Parameter.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}

export default function SelectParameter_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectParameter {...props} navigation={navigation} location={location} params={params} />;
  }
